module.exports = __webpack_public_path__ + "d213a39.woff2";